import React from 'react';
import classNames from 'classnames';
import styles from './Surface.less';
import {
  useBoardsMenuVisibility,
  BoardsMenuVisibilityState,
} from 'app/src/components/BoardsMenuVisibility';

export const Surface: React.FunctionComponent = ({ children }) => {
  const { boardsMenuVisibility } = useBoardsMenuVisibility();

  return (
    <div
      id="surface"
      className={classNames(
        styles.surface,
        boardsMenuVisibility === BoardsMenuVisibilityState.PINNED &&
          styles.pinnedBoardsMenu,
      )}
    >
      {children}
    </div>
  );
};
